'use strict';

(function ($) {
    $(document).on("hidden.bs.modal", ".modal", function (event) {
        $(this).removeClass("modal-stack");
        $("body").data("open_modals", $("body").data("open_modals") - 1);

        if ($("body").data("open_modals") > 0) {
            $("body").addClass('modal-open');
        }

        if (window.agPageFocusStack && window.agPageFocusStack.length > 0) {
            window.agPageFocusStack.forEach(function (vm) {
                vm.setFocused(false);
            });

            if ($(this).hasClass('ag-page'))
            window.agPageFocusStack.pop();

            if (window.agPageFocusStack.length > 0)
                window.agPageFocusStack[window.agPageFocusStack.length - 1].setFocused(true);
        }
    });
    $(document).on("shown.bs.modal", ".modal", function (event) {
        if (typeof ($("body").data("open_modals")) == "undefined") {
            $("body").data("open_modals", 0);
        }
        if ($(this).hasClass("modal-stack")) {
            return;
        }
        $(this).addClass("modal-stack");
        $("body").data("open_modals", $("body").data("open_modals") + 1);
        $(this).css("z-index", 1040 + (10 * $("body").data("open_modals")));
        $(".modal-backdrop").not(".modal-stack").css("z-index", 1039 + (10 * $("body").data("open_modals")));
        $(".modal-backdrop").not(".modal-stack").addClass("modal-stack");

        if (window.agPageFocusStack && window.agPageFocusStack.length > 0) {
            window.agPageFocusStack.forEach(function (vm) {
                vm.setFocused(false);
            });
            window.agPageFocusStack[window.agPageFocusStack.length - 1].setFocused(true);
        }
    });
})(jQuery);